<template>
  <div class="main-container">
    <TheSideBar>
      <router-link :to="{name: 'resourcesList', params: { status: '$active' } }">
        <i class="fas fa-list"></i>
        {{ $t('resource.list') }}
      </router-link>
      <router-link :to="{name: 'resourcesList', params: { status: '$deleted' } }">
        <i class="fas fa-trash" style="color: OrangeRed"></i>
        koš
      </router-link>
      <router-link v-if="$store.getters.currentUserHasAction('ADD_RESOURCE')" :to="{name: 'resourcesNew'}">
        <i class="fas fa-plus-circle"></i>
        {{ $t('resource.new') }}
      </router-link>
      <hr data-v-fbc2ff5e="" class="separator">
      <router-link v-if="$store.getters.currentUserHasAction('MANAGE_RESOURCE_TYPES')" :to="{name: 'resourceTypesList'}">
        <i class="fas fa-list"></i>
        {{ $t('resource.type.list') }}
      </router-link>
      <router-link v-if="$store.getters.currentUserHasAction('MANAGE_RESOURCE_TYPES')" :to="{name: 'resourceTypeNew'}">
        <i class="fas fa-plus-circle"></i>
        {{ $t('resource.type.new') }}
      </router-link>
    </TheSideBar>
    <DataReady id="content">
      <router-view :key="$route.path"></router-view>
    </DataReady>
  </div>
</template>

<script>
import TheSideBar from 'CORE/components/side-bar/the-side-bar'
import DataReady from 'CORE/components/utilities/data-ready'

export default {
    name: 'ResourcesView',
    components: {
        TheSideBar,
        DataReady,
    },
}
</script>
